import {
  BoxLargeImgWrap,
  BoxLargeImgInner,
  BoxLargeImgMedia,
  BoxLargeImgContent,
  HeadingWrap,
  CategoryWrap,
  TextWrap,
  ImgWrapper
} from './style'

const BoxLargeImage = ({
  image,
  title,
  category,
  desc,
  path,
  className,
  layout,
  ...restProps
}) => {
  return (
    <BoxLargeImgWrap
      href={path}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      {...restProps}
    >
      <BoxLargeImgInner>
        {image?.src && (
          <BoxLargeImgMedia>
            <ImgWrapper>
              <img
                src={image.src.localFile.publicURL || image.src}
                alt={image.src.alternativeText || title}
              />
            </ImgWrapper>
          </BoxLargeImgMedia>
        )}
        <BoxLargeImgContent $layout={layout}>
          {title && (
            <HeadingWrap as="h5" $layout={layout}>
              {title}
            </HeadingWrap>
          )}
          {category && <CategoryWrap>{category}</CategoryWrap>}
          {desc && (
            <TextWrap
              $layout={layout}
              dangerouslySetInnerHTML={{
                __html: desc
              }}
            />
          )}
        </BoxLargeImgContent>
      </BoxLargeImgInner>
    </BoxLargeImgWrap>
  )
}

export default BoxLargeImage
